import { render } from "./BalanceSheetTable.vue?vue&type=template&id=6acc9e7c&scoped=true"
import script from "./BalanceSheetTable.vue?vue&type=script&lang=js"
export * from "./BalanceSheetTable.vue?vue&type=script&lang=js"

import "./BalanceSheetTable.vue?vue&type=style&index=0&id=6acc9e7c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acc9e7c"]])

export default __exports__